<template>
  <div class="admin-attendance">
    <el-container>
      <!-- 顶部导航 -->
      <el-header class="admin-header">
        <div class="header-left">
          <h2>考勤管理</h2>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleNavCommand" class="nav-dropdown">
            <el-button type="text">
              导航菜单 <i class="el-icon-arrow-down"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/admin/home">
                <i class="el-icon-s-home"></i> 首页
              </el-dropdown-item>
              <el-dropdown-item command="/admin/orders">
                <i class="el-icon-document"></i> 工单管理
              </el-dropdown-item>
              <el-dropdown-item command="/admin/users">
                <i class="el-icon-user"></i> 用户管理
              </el-dropdown-item>
              <el-dropdown-item command="/admin/attendance">
                <i class="el-icon-time"></i> 考勤管理
              </el-dropdown-item>
              <el-dropdown-item command="/admin/salary">
                <i class="el-icon-money"></i> 薪资管理
              </el-dropdown-item>
              <el-dropdown-item command="/admin/statistics">
                <i class="el-icon-s-data"></i> 统计报表
              </el-dropdown-item>
              <el-dropdown-item command="/admin/settings">
                <i class="el-icon-setting"></i> 系统设置
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button @click="$router.push('/admin/home')">返回首页</el-button>
        </div>
      </el-header>

      <!-- 主内容区 -->
      <el-main class="admin-main">

        <!-- 统计卡片 -->
        <el-row :gutter="20" class="stats-row">
          <el-col :span="6">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-icon" style="background: #409EFF;">
                  <i class="el-icon-user"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ statistics.summary.totalWorkers }}</div>
                  <div class="stat-label">员工总数</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-icon" style="background: #67C23A;">
                  <i class="el-icon-success"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ statistics.summary.totalPresentDays }}</div>
                  <div class="stat-label">出勤天数</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-icon" style="background: #E6A23C;">
                  <i class="el-icon-time"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ statistics.summary.totalWorkHours.toFixed(0) }}</div>
                  <div class="stat-label">工作时长(小时)</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-icon" style="background: #F56C6C;">
                  <i class="el-icon-timer"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ statistics.summary.totalOvertimeHours.toFixed(0) }}</div>
                  <div class="stat-label">加班时长(小时)</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <!-- 筛选器 -->
        <el-card class="filter-card">
          <el-form :model="filterForm" :inline="true" class="filter-form">
            <el-form-item label="年月">
              <el-date-picker
                v-model="filterForm.month"
                type="month"
                placeholder="选择月份"
                format="yyyy-MM"
                value-format="yyyy-MM"
                @change="loadData"
                clearable>
              </el-date-picker>
            </el-form-item>
            <el-form-item label="员工">
              <el-select
                v-model="filterForm.workerId"
                placeholder="选择员工"
                @change="loadAttendanceRecords"
                clearable>
                <el-option
                  v-for="worker in workers"
                  :key="worker.id"
                  :label="worker.name"
                  :value="worker.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select
                v-model="filterForm.status"
                placeholder="选择状态"
                @change="loadAttendanceRecords"
                clearable>
                <el-option label="出勤" value="present"></el-option>
                <el-option label="缺勤" value="absent"></el-option>
                <el-option label="迟到" value="late"></el-option>
                <el-option label="请假" value="leave"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loadAttendanceRecords">
                <i class="el-icon-search"></i>
                搜索
              </el-button>
              <el-button @click="resetFilter">重置</el-button>
              <el-button type="success" @click="showAddDialog">
                <i class="el-icon-plus"></i>
                添加记录
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 员工考勤统计 -->
        <el-card class="worker-stats-card">
          <div slot="header" class="card-header">
            <span>员工考勤统计 ({{ statistics.year }}-{{ String(statistics.month).padStart(2, '0') }})</span>
          </div>

          <el-table 
            :data="statistics.statistics" 
            v-loading="loadingStats"
            style="width: 100%"
            empty-text="暂无统计数据"
          >
            <el-table-column prop="worker_name" label="员工姓名" width="120"></el-table-column>
            <el-table-column prop="present_days" label="出勤天数" width="80" align="center">
              <template slot-scope="scope">
                <el-tag type="success" size="mini">{{ scope.row.present_days }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="absent_days" label="缺勤天数" width="80" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.absent_days > 0" type="danger" size="mini">
                  {{ scope.row.absent_days }}
                </el-tag>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column prop="late_days" label="迟到天数" width="80" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.late_days > 0" type="warning" size="mini">
                  {{ scope.row.late_days }}
                </el-tag>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column prop="leave_days" label="请假天数" width="80" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.leave_days > 0" type="info" size="mini">
                  {{ scope.row.leave_days }}
                </el-tag>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column prop="total_work_hours" label="工作时长" width="100" align="center">
              <template slot-scope="scope">
                {{ parseFloat(scope.row.total_work_hours).toFixed(1) }}小时
              </template>
            </el-table-column>
            <el-table-column prop="total_overtime_hours" label="加班时长" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.total_overtime_hours > 0" class="overtime">
                  {{ parseFloat(scope.row.total_overtime_hours).toFixed(1) }}小时
                </span>
                <span v-else>0小时</span>
              </template>
            </el-table-column>
            <el-table-column label="出勤率" width="80" align="center">
              <template slot-scope="scope">
                <el-progress
                  :percentage="calculateAttendanceRate(scope.row)"
                  :color="getAttendanceRateColor(scope.row)"
                  :stroke-width="8"
                  text-inside
                ></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <!-- 考勤记录 -->
        <el-card class="records-card">
          <div slot="header" class="card-header">
            <span>考勤记录</span>
          </div>

          <el-table 
            :data="attendanceRecords" 
            v-loading="loadingRecords"
            style="width: 100%"
            empty-text="暂无考勤记录"
          >
            <el-table-column prop="worker_name" label="员工姓名" width="120"></el-table-column>
            <el-table-column prop="date" label="日期" width="120">
              <template slot-scope="scope">
                {{ formatDate(scope.row.date) }}
              </template>
            </el-table-column>
            <el-table-column prop="check_in_time" label="签到时间" width="100">
              <template slot-scope="scope">
                {{ scope.row.check_in_time || '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="check_out_time" label="签退时间" width="100">
              <template slot-scope="scope">
                {{ scope.row.check_out_time || '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="work_hours" label="工作时长" width="100">
              <template slot-scope="scope">
                {{ scope.row.work_hours ? scope.row.work_hours + '小时' : '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="overtime_hours" label="加班时长" width="140">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center;">
                  <el-input-number
                    v-model="scope.row.overtime_hours"
                    :min="0"
                    :step="0.5"
                    :precision="1"
                    size="mini"
                    controls-position="right"
                    style="width: 80px;"
                    @change="updateOvertimeHours(scope.row)"
                  ></el-input-number>
                  <span style="margin-left: 5px; font-size: 12px; color: #666;">小时</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
              <template slot-scope="scope">
                <el-tag 
                  :type="getStatusType(scope.row.status)"
                  size="mini"
                >
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="notes" label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="editRecord(scope.row)"
                >
                  编辑
                </el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  style="color: #f56c6c;"
                  @click="deleteRecord(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-main>
    </el-container>

    <!-- 添加/编辑考勤记录对话框 -->
    <el-dialog
      :title="recordDialogTitle"
      :visible.sync="recordDialogVisible"
      width="500px"
    >
      <el-form 
        :model="recordForm" 
        :rules="recordRules"
        ref="recordForm"
        label-width="80px"
      >
        <el-form-item label="员工" prop="workerId">
          <el-select 
            v-model="recordForm.workerId" 
            placeholder="选择员工"
            style="width: 100%"
            :disabled="isEditMode"
          >
            <el-option
              v-for="worker in workers"
              :key="worker.id"
              :label="worker.name"
              :value="worker.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="recordForm.date"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            :disabled="isEditMode"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="签到时间">
          <el-time-picker
            v-model="recordForm.checkInTime"
            placeholder="选择签到时间"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            style="width: 100%"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="签退时间">
          <el-time-picker
            v-model="recordForm.checkOutTime"
            placeholder="选择签退时间"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            style="width: 100%"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="加班时长">
          <el-input-number
            v-model="recordForm.overtimeHours"
            :min="0"
            :step="0.5"
            :precision="1"
            controls-position="right"
            style="width: 100%"
          >
            <template slot="append">小时</template>
          </el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="recordForm.status" placeholder="选择状态" style="width: 100%">
            <el-option label="出勤" value="present"></el-option>
            <el-option label="缺勤" value="absent"></el-option>
            <el-option label="迟到" value="late"></el-option>
            <el-option label="请假" value="leave"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="recordForm.notes"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="recordDialogVisible = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="saveRecord"
          :loading="recordSubmitting"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AttendanceManagement',
  data() {
    return {

      loadingStats: false,
      loadingRecords: false,
      
      // 筛选
      filterForm: {
        month: '',
        workerId: null,
        status: null
      },
      
      // 统计数据
      statistics: {
        summary: {
          totalWorkers: 0,
          totalPresentDays: 0,
          totalAbsentDays: 0,
          totalWorkHours: 0,
          totalOvertimeHours: 0
        },
        statistics: [],
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      },
      
      // 考勤记录
      attendanceRecords: [],
      
      // 员工列表
      workers: [],
      
      // 记录对话框
      recordDialogVisible: false,
      recordSubmitting: false,
      isEditMode: false,
      editingRecordId: null,
      recordForm: {
        workerId: null,
        date: '',
        checkInTime: null,
        checkOutTime: null,
        overtimeHours: 0,
        status: 'present',
        notes: ''
      },
      recordRules: {
        workerId: [
          { required: true, message: '请选择员工', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    recordDialogTitle() {
      return this.isEditMode ? '编辑考勤记录' : '添加考勤记录'
    }
  },
  async created() {
    this.initializeData()
    await this.loadWorkers()
    await this.loadData()
  },
  methods: {
    // 初始化数据
    initializeData() {
      const now = new Date()
      this.filterForm.month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
    },
    
    // 加载数据
    async loadData() {
      await this.loadStatistics()
      await this.loadAttendanceRecords()
    },
    
    // 加载员工列表
    async loadWorkers() {
      try {
        const response = await this.$http.get('/api/admin/users/workers')
        if (response.success) {
          this.workers = response.data.filter(w => w.status === 'active')
        }
      } catch (error) {
        console.error('加载员工列表失败:', error)
      }
    },
    
    // 加载统计数据
    async loadStatistics() {
      try {
        this.loadingStats = true
        const params = {}
        if (this.filterForm.month) {
          const [year, month] = this.filterForm.month.split('-')
          params.year = year
          params.month = month
        }
        
        const response = await this.$http.get('/api/attendance/statistics', { params })
        if (response.success) {
          this.statistics = response.data
        }
      } catch (error) {
        console.error('加载统计数据失败:', error)
        this.$message.error('加载统计数据失败')
      } finally {
        this.loadingStats = false
      }
    },
    
    // 加载考勤记录
    async loadAttendanceRecords() {
      try {
        this.loadingRecords = true
        const params = {}
        
        if (this.filterForm.month) {
          const [year, month] = this.filterForm.month.split('-')
          params.year = year
          params.month = month
        }
        
        if (this.filterForm.workerId) {
          params.workerId = this.filterForm.workerId
        }
        
        if (this.filterForm.status) {
          params.status = this.filterForm.status
        }
        
        const response = await this.$http.get('/api/attendance/all-records', { params })
        if (response.success) {
          this.attendanceRecords = response.data
        }
      } catch (error) {
        console.error('加载考勤记录失败:', error)
        this.$message.error('加载考勤记录失败')
      } finally {
        this.loadingRecords = false
      }
    },
    
    // 重置筛选
    resetFilter() {
      this.filterForm = {
        month: '',
        workerId: null,
        status: null
      }
      this.loadData()
    },
    
    // 显示添加对话框
    showAddDialog() {
      this.isEditMode = false
      this.editingRecordId = null
      this.recordForm = {
        workerId: null,
        date: '',
        checkInTime: null,
        checkOutTime: null,
        overtimeHours: 0,
        status: 'present',
        notes: ''
      }
      this.recordDialogVisible = true
    },
    
    // 编辑记录
    editRecord(record) {
      this.isEditMode = true
      this.editingRecordId = record.id
      this.recordForm = {
        workerId: record.worker_id,
        date: record.date,
        checkInTime: record.check_in_time,
        checkOutTime: record.check_out_time,
        overtimeHours: record.overtime_hours || 0,
        status: record.status,
        notes: record.notes || ''
      }
      this.recordDialogVisible = true
    },
    
    // 保存记录
    async saveRecord() {
      try {
        await this.$refs.recordForm.validate()
        this.recordSubmitting = true
        
        const data = {
          workerId: this.recordForm.workerId,
          date: this.recordForm.date,
          checkInTime: this.recordForm.checkInTime,
          checkOutTime: this.recordForm.checkOutTime,
          overtimeHours: this.recordForm.overtimeHours,
          status: this.recordForm.status,
          notes: this.recordForm.notes
        }
        
        const response = await this.$http.post('/api/attendance/records', data)
        
        if (response.success) {
          this.$message.success('保存成功')
          this.recordDialogVisible = false
          await this.loadData()
        } else {
          this.$message.error(response.message)
        }
      } catch (error) {
        if (error.message !== 'validation failed') {
          console.error('保存记录失败:', error)
          this.$message.error('保存失败')
        }
      } finally {
        this.recordSubmitting = false
      }
    },
    
    // 删除记录
    deleteRecord(record) {
      this.$confirm('确定要删除这条考勤记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$http.delete(`/api/attendance/records/${record.id}`)
          if (response.success) {
            this.$message.success('删除成功')
            await this.loadData()
          } else {
            this.$message.error(response.message)
          }
        } catch (error) {
          console.error('删除记录失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    
    // 计算出勤率
    calculateAttendanceRate(worker) {
      const total = worker.present_days + worker.absent_days + worker.late_days + worker.leave_days
      if (total === 0) return 0
      return Math.round((worker.present_days / total) * 100)
    },
    
    // 获取出勤率颜色
    getAttendanceRateColor(worker) {
      const rate = this.calculateAttendanceRate(worker)
      if (rate >= 95) return '#67C23A'
      if (rate >= 80) return '#E6A23C'
      return '#F56C6C'
    },
    
    // 格式化日期
    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('zh-CN', {
        month: '2-digit',
        day: '2-digit'
      })
    },
    
    // 获取状态标签类型
    getStatusType(status) {
      const types = {
        present: 'success',
        absent: 'danger',
        late: 'warning',
        leave: 'info'
      }
      return types[status] || 'info'
    },
    
    // 获取状态文本
    getStatusText(status) {
      const texts = {
        present: '出勤',
        absent: '缺勤',
        late: '迟到',
        leave: '请假'
      }
      return texts[status] || status
    },
    
    // 更新加班时长
    async updateOvertimeHours(record) {
      try {
        const response = await fetch(`/api/attendance/overtime/${record.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            overtimeHours: record.overtime_hours || 0
          })
        })
        
        const result = await response.json()
        
        if (result.success) {
          this.$message.success('加班时长设置成功')
          // 重新加载统计数据
          this.loadStatistics()
        } else {
          this.$message.error(result.message)
          // 恢复原值
          this.loadAttendanceRecords()
        }
      } catch (error) {
        console.error('设置加班时长失败:', error)
        this.$message.error('设置失败')
        // 恢复原值
        this.loadAttendanceRecords()
      }
    },
    
    // 处理导航命令
    handleNavCommand(command) {
      this.$router.push(command)
    },
    
    // 生成月度报告
    async generateMonthlyReport() {
      try {
        this.$message.info('正在生成月度报告...')
        
        const [year, month] = (this.filterForm.month || new Date().toISOString().slice(0, 7)).split('-')
        
        // 生成报告内容
        const reportData = {
          title: `${year}年${month}月考勤报告`,
          period: `${year}-${month}`,
          summary: this.statistics.summary,
          statistics: this.statistics.statistics,
          totalRecords: this.attendanceRecords.length
        }
        
        // 创建报告文本
        let reportContent = `${reportData.title}\n`
        reportContent += `报告期间：${reportData.period}\n\n`
        reportContent += `=== 汇总统计 ===\n`
        reportContent += `员工总数：${reportData.summary.totalWorkers}\n`
        reportContent += `出勤天数：${reportData.summary.totalPresentDays}\n`
        reportContent += `工作时长：${reportData.summary.totalWorkHours.toFixed(1)}小时\n`
        reportContent += `加班时长：${reportData.summary.totalOvertimeHours.toFixed(1)}小时\n\n`
        
        reportContent += `=== 员工明细 ===\n`
        reportData.statistics.forEach(worker => {
          reportContent += `${worker.worker_name}：出勤${worker.present_days}天，缺勤${worker.absent_days}天，迟到${worker.late_days}天，请假${worker.leave_days}天\n`
        })
        
        // 下载报告
        const blob = new Blob([reportContent], { type: 'text/plain;charset=utf-8;' })
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', `月度考勤报告_${year}-${month}.txt`)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        this.$message.success('月度报告生成成功')
      } catch (error) {
        console.error('生成月度报告失败:', error)
        this.$message.error('生成报告失败')
      }
    }
  }
}
</script>

<style scoped>
.admin-attendance {
  min-height: 100vh;
  background: #f0f2f5;
}

.admin-header {
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.header-left h2 {
  margin: 0;
  color: #303133;
}

.admin-main {
  background: #f0f2f5;
  padding: 20px;
}

.stats-row {
  margin-bottom: 30px;
}

.stat-card {
  border-radius: 15px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.stat-content {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  color: white;
  font-size: 24px;
}

.stat-number {
  font-size: 32px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}

.stat-label {
  color: #6c757d;
  font-size: 14px;
}

.filter-card,
.worker-stats-card,
.records-card {
  margin-bottom: 30px;
  border-radius: 20px;
  border: none;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.card-header {
  font-weight: bold;
  font-size: 18px;
  color: #2c3e50;
}

.filter-form {
  margin: 0;
}

.overtime {
  color: #f56c6c;
  font-weight: bold;
}



/* 移动端样式 */
@media (max-width: 768px) {
  .admin-main {
    padding: 15px;
  }

  .stats-row .el-col {
    margin-bottom: 15px;
  }

  .filter-form .el-form-item {
    margin-bottom: 10px;
  }

  .header-left h2 {
    font-size: 18px;
  }

  .header-right .nav-dropdown {
    margin-right: 10px;
  }
}
</style>